const language_ES = {

    es: 'Español',
    en: 'Ingles',
    choose_language: 'Eligir idioma',

    sing_to_continue : 'Iniciar sesión para continuar',
    email : 'Correo electrónico',
    password : 'Contraseña',
    remember_me : 'Recordarme',
    forgot_password : 'Olvide mi contraseña',
    sign_in : 'Iniciar sesión',

    search: 'Busqueda',
    property_search: 'Propiedad',
    property_search_placeholder: 'Buscar propiedad',
    recently_searched : 'Buscado recientemente'
}

export {
    language_ES
}